import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import MainProvider from "./providers/mainProvider";
import { BrowserRouter } from "react-router-dom";
import "./index.css"; // optional

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MainProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </MainProvider>
  </React.StrictMode>
);
